import * as React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SomeFunction = (...args: any[]) => void | Promise<void>;
type Timer = ReturnType<typeof setTimeout>;

export const useDebounce = (func: SomeFunction, delay: number) => {
  const timerRef = React.useRef<Timer>(undefined);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const debouncedFunction = (...args: any[]) => {
    const newTimer = setTimeout(() => {
      if (typeof func === 'function') {
        func(...args);
      }
    }, delay);
    clearTimeout(timerRef.current); //Cancel previous timers
    timerRef.current = newTimer; //Save latest timer
  };

  React.useEffect(() => {
    const timer = timerRef.current;

    return () => {
      if (timer) return;
      clearTimeout(timer);
    };
  }, []);

  return debouncedFunction;
};
